/*
 * Modal
 */
import RooModal from './Modal';
import RooConfirm from './Confirm';
import RooWithConfirm from './WithConfirm';
RooModal.confirm = RooConfirm;
RooModal.WithConfirm = RooWithConfirm;
export var Confirm = RooConfirm;
export var WithConfirm = RooWithConfirm;
export * from './interface';
export default RooModal;